//import node_modules
import React, { FunctionComponent } from "react";
import { Container, Row, Col } from "react-bootstrap";

//types
import type { BlogDocument } from "@adjust/libs/database/blogs";

//components
import BlogPreviewComponent from "./PreviewComponent";

//styles
import { subHeaderCSS } from "@adjust/website/src/styles/shared";

type RecommendationBlogsProps = {
  recommendations: BlogDocument[];
};

const RecommendationBlogsComponent: FunctionComponent<RecommendationBlogsProps> = ({ recommendations }) => {
  return (
    <Container className="my-3">
      <div className={subHeaderCSS}>More From AdjustToTheGoodLifeTravel</div>
      <Row className="justify-content-center">
        {recommendations.map((recommendation) => (
          <Col sm={12} md={6} xl={4} key={recommendation.slug}>
            <BlogPreviewComponent recommendation={recommendation} />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default React.memo(RecommendationBlogsComponent);
